/* ############################################################################################################## */
// PROBENSORTIMENT CART CHECK - Verhindert mehrfaches Hinzufügen
// ===========================================================================
window.addEventListener('DOMContentLoaded', () => {
  console.log('🧪 Probensortiment Cart Check gestartet');
  
  // Hole Product-ID aus dem versteckten Input
  const productIdInput = document.querySelector('input[name="product-id"]');
  const currentProductId = productIdInput ? productIdInput.value : null;
  
  if (!currentProductId) {
    console.warn('⚠️ Keine Product-ID gefunden');
    return;
  }
  
  console.log(`📦 Product-ID gefunden: ${currentProductId}`);
  
  // Hole Product Handle aus URL
  const productHandle = window.location.pathname.split('/').pop().split('?')[0];
  console.log(`📦 Product Handle: ${productHandle}`);
  
  // Finde den Add-to-Cart Button (dein spezifischer Button)
  const addToCartButton = document.querySelector('button[name="add"].product-form__submit');
  
  if (!addToCartButton) {
    console.warn('⚠️ Kein Add-to-Cart Button gefunden');
    return;
  }
  
  console.log('✅ Add-to-Cart Button gefunden:', addToCartButton);
  
  // Finde das <span> Element im Button
  const buttonSpan = addToCartButton.querySelector('span');
  const originalButtonText = buttonSpan ? buttonSpan.textContent.trim() : addToCartButton.textContent.trim();
  const originalButtonDisabled = addToCartButton.disabled;
  
  console.log(`📝 Original Button-Text: "${originalButtonText}"`);
  
  // Funktion: Prüfe ob Produkt bereits im Cart ist
  async function checkCartForProduct() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      console.log(`🛒 Cart Items: ${cart.items.length}`);
      
      // Prüfe ob das aktuelle Probensortiment im Cart ist
      const productInCart = cart.items.some(item => {
        // Prüfung über Product-ID (primär)
        if (item.product_id == currentProductId) {
          console.log(`✓ Match via Product-ID: ${item.product_id} (${item.product_title})`);
          return true;
        }
        
        // Prüfung über Handle (Fallback)
        if (item.handle === productHandle) {
          console.log(`✓ Match via Handle: ${item.handle}`);
          return true;
        }
        
        return false;
      });
      
      if (productInCart) {
        console.log('🚫 Probensortiment bereits im Warenkorb - Button wird deaktiviert');
        disableAddToCartButton();
      } else {
        console.log('✅ Probensortiment NICHT im Warenkorb - Button aktiv');
        enableAddToCartButton();
      }
      
    } catch (error) {
      console.error('❌ Fehler beim Cart-Check:', error);
      // Im Fehlerfall: Button aktiv lassen
      enableAddToCartButton();
    }
  }
  
  // Funktion: Button deaktivieren
  function disableAddToCartButton() {
    addToCartButton.disabled = true;
    addToCartButton.classList.add('disabled', 'btn--disabled');
    
    // Text im <span> ändern
    if (buttonSpan) {
      buttonSpan.textContent = '✓ Bereits im Warenkorb';
    } else {
      addToCartButton.textContent = '✓ Bereits im Warenkorb';
    }
    
    // Visuelles Feedback
    addToCartButton.style.opacity = '0.6';
    addToCartButton.style.cursor = 'not-allowed';
    addToCartButton.style.pointerEvents = 'none';
    
    // Verhindere Form-Submit komplett
    const productForm = addToCartButton.closest('form');
    if (productForm) {
      productForm.addEventListener('submit', preventFormSubmit, true);
    }
  }
  
  // Funktion: Button aktivieren
  function enableAddToCartButton() {
    addToCartButton.disabled = originalButtonDisabled;
    addToCartButton.classList.remove('disabled', 'btn--disabled');
    
    // Original-Text wiederherstellen
    if (buttonSpan) {
      buttonSpan.textContent = originalButtonText;
    } else {
      addToCartButton.textContent = originalButtonText;
    }
    
    // Visuelles Feedback zurücksetzen
    addToCartButton.style.opacity = '';
    addToCartButton.style.cursor = '';
    addToCartButton.style.pointerEvents = '';
    
    // Event Listener entfernen
    const productForm = addToCartButton.closest('form');
    if (productForm) {
      productForm.removeEventListener('submit', preventFormSubmit, true);
    }
  }
  
  // Funktion: Verhindere Form-Submit
  function preventFormSubmit(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    
    console.log('🚫 Form-Submit verhindert - Produkt bereits im Warenkorb');
    
    // Zeige Benachrichtigung
    showNotification('Dieses Probensortiment befindet sich bereits in Ihrem Warenkorb.');
    
    return false;
  }
  
  // Funktion: Zeige Benachrichtigung
  function showNotification(message) {
    // Erstelle Benachrichtigung
    const notification = document.createElement('div');
    notification.className = 'probensortiment-notification';
    notification.style.cssText = `
      position: fixed;
      top: 80px;
      left: 50%;
      transform: translateX(-50%);
      background: #3b82f6;
      color: white;
      padding: 16px 24px;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      z-index: 999999;
      font-size: 15px;
      font-weight: 500;
      max-width: 90%;
      text-align: center;
      animation: slideDown 0.3s ease-out;
    `;
    notification.textContent = message;
    
    document.body.appendChild(notification);
    
    // Entferne nach 4 Sekunden
    setTimeout(() => {
      notification.style.animation = 'slideUp 0.3s ease-in';
      setTimeout(() => notification.remove(), 300);
    }, 4000);
  }
  
  // Initiale Prüfung beim Laden
  checkCartForProduct();
  
  // Prüfe bei jedem Cart-Update
  document.addEventListener('cart:updated', () => {
    console.log('🔄 Cart wurde aktualisiert - prüfe erneut');
    setTimeout(() => checkCartForProduct(), 300);
  });
  
  // Prüfe wenn der Cart Drawer geöffnet/geschlossen wird
  document.addEventListener('cart:refresh', () => {
    console.log('🔄 Cart Refresh - prüfe erneut');
    setTimeout(() => checkCartForProduct(), 300);
  });
  
  // Prüfe nach AJAX Add-to-Cart
  document.addEventListener('product:added-to-cart', () => {
    console.log('🔄 Produkt zum Cart hinzugefügt - prüfe erneut');
    setTimeout(() => checkCartForProduct(), 500);
  });
  
  // Prüfe nach product-form Events (falls vorhanden)
  const productForm = addToCartButton.closest('form[is="product-form"]');
  if (productForm) {
    productForm.addEventListener('variant:change', () => {
      console.log('🔄 Variante geändert - prüfe erneut');
      setTimeout(() => checkCartForProduct(), 200);
    });
  }
  
  console.log('✅ Probensortiment Cart Check initialisiert');
});

// CSS Animations
const style = document.createElement('style');
style.textContent = `
  @keyframes slideDown {
    from {
      transform: translateX(-50%) translateY(-20px);
      opacity: 0;
    }
    to {
      transform: translateX(-50%) translateY(0);
      opacity: 1;
    }
  }
  
  @keyframes slideUp {
    from {
      transform: translateX(-50%) translateY(0);
      opacity: 1;
    }
    to {
      transform: translateX(-50%) translateY(-20px);
      opacity: 0;
    }
  }
  
  /* Deaktivierter Button Style */
  button[name="add"].btn--disabled,
  button[name="add"].product-form__submit:disabled {
    background-color: #e5e7eb !important;
    color: #6b7280 !important;
    cursor: not-allowed !important;
    opacity: 0.6 !important;
    border-color: #d1d5db !important;
  }
  
  button[name="add"].btn--disabled:hover {
    background-color: #e5e7eb !important;
    transform: none !important;
  }
`;
document.head.appendChild(style);
/* ############################################################################################################## */